<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>MY_SETUP</h4>
  <button type="button" class="close" aria-label="Close" (click)="crossClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <nav ngbNav #nav="ngbNav" class="nav-tabs" [formGroup]="form">
    <ng-container ngbNavItem>
      <a ngbNavLink translate (click)="tabChange('CALCULATIONS')">CALCULATIONS</a>
      <ng-template ngbNavContent>
        <div class="row">
          <div class="col-12 col-md-6">
            <label translate>CURRENCY</label>
            <lib-meta-data-select-input
              suppressLabel="true"
              formControlName="currency"
              table="xx"
              metaId="valkod"
              metaDisplay="valkod"
              [showId]="false"
              class="gung-select-input-sm"
            ></lib-meta-data-select-input>
            <lib-gung-number-input gungTranslate="CURRENCY_RATE" formControlName="currencyRate"></lib-gung-number-input>
          </div>
          <div class="col-12 col-md-6">
            <lib-gung-number-input
              [minValue]="0"
              gungTranslate="MARK_UP"
              formControlName="markUp"
            ></lib-gung-number-input>
          </div>
        </div>
      </ng-template>
    </ng-container>
    <ng-container ngbNavItem>
      <a ngbNavLink translate (click)="tabChange('COMPANY_INFORMATION')">COMPANY_INFORMATION</a>
      <ng-template ngbNavContent>
        <div class="row">
          <div class="col-12 col-md-6">
            <lib-gung-text-input gungTranslate="COMPANY_NAME" formControlName="name"></lib-gung-text-input>
            <lib-gung-text-input gungTranslate="ADDRESS1" formControlName="address1"></lib-gung-text-input>
            <lib-gung-text-input gungTranslate="ADDRESS2" formControlName="address2"></lib-gung-text-input>
            <lib-gung-text-input gungTranslate="ZIP" formControlName="zipCode"></lib-gung-text-input>
            <lib-gung-text-input gungTranslate="CITY" formControlName="city"></lib-gung-text-input>
          </div>
          <div class="col-12 col-md-6">
            <lib-gung-text-input gungTranslate="ORG_NUMBER" formControlName="organizationNumber"></lib-gung-text-input>
            <lib-gung-text-input gungTranslate="EMAIL_ADDRESS" formControlName="email"></lib-gung-text-input>
            <lib-gung-text-input gungTranslate="TELEPHONE" formControlName="telephone"></lib-gung-text-input>
            <lib-gung-text-input gungTranslate="WEBADDRESS" formControlName="webAddress"></lib-gung-text-input>
            <div formGroupName="extra">
              <lib-gung-select-option-input
                gungTranslate="LANGUAGE_QUOTATION_TEMPLATE"
                [optionsList]="optionsListLanguage"
                formControlName="language"
              >
              </lib-gung-select-option-input>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
    <ng-container ngbNavItem>
      <a ngbNavLink translate (click)="tabChange('CONDITIONS')">CONDITIONS</a>
      <ng-template ngbNavContent>
        <div formGroupName="extra">
          <div class="row" formGroupName="quotations">
            <div class="col-12 col-md-6">
              <lib-gung-text-input gungTranslate="CUSTOMER" formControlName="customer"></lib-gung-text-input>
              <lib-gung-text-input gungTranslate="YOUR_REFERENCE" formControlName="yourReference"></lib-gung-text-input>
              <lib-gung-text-input gungTranslate="NOTES" formControlName="notes"></lib-gung-text-input>
            </div>
            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col-md-6">
                  <label translate>DATE</label>
                  <div class="input-group">
                    <input
                      class="form-control"
                      placeholder="yyyy-mm-dd"
                      name="datePicker"
                      ngbDatepicker
                      #d1="ngbDatepicker"
                      formControlName="date"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="d1.toggle()" type="button">
                        <i class="fal fa-calendar-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <label translate>EXPIRE_DATE</label>
                  <div class="input-group">
                    <input
                      class="form-control"
                      placeholder="yyyy-mm-dd"
                      name="expireDatePicker"
                      ngbDatepicker
                      #d2="ngbDatepicker"
                      formControlName="expireDate"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button">
                        <i class="fal fa-calendar-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <lib-gung-text-input gungTranslate="OUR_REFERENCE" formControlName="ourReference"></lib-gung-text-input>
              <lib-gung-text-input gungTranslate="PAYMENT_TERMS" formControlName="paymentTerms"></lib-gung-text-input>
              <lib-gung-text-input gungTranslate="DELIVERY_TERMS" formControlName="deliveryTerms"></lib-gung-text-input>
              <!--    <lib-meta-select-input formControlName="paymentTerms" table="x2" metaId="betkod" metaDisplay="betvillbeskr" [supressedLabel]="true">
              </lib-meta-select-input>
              <lib-meta-select-input formControlName="deliveryTerms" table="x2e" metaId="levvillkkod" metaDisplay="levvillkbeskr" [suppressLabel]="true" >
              </lib-meta-select-input> -->
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </nav>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="resetForm()" translate>RESET</button>
  <span translate *ngIf="saved">SAVED</span>
  <button type="button" class="btn btn-primary ml-auto" (click)="save($event)" translate>SAVE</button>
</div>
